/* eslint-disable no-useless-constructor */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { addBackgroundImageToPage } from '../../redux/actions/entities/pages';
import { saveState } from '../../redux/actions/entities/io';


class CategoryColors extends Component {
  constructor(props) {
    super(props);
  }

  setBackgroundImage = (image) => {
    const {
      dispatch, layouts, backgrounds,
    } = this.props;
    dispatch(addBackgroundImageToPage(image.parentCategory, layouts, backgrounds.backgrounds, image.fileName));
    dispatch(saveState());
  }

  renderColors = () => {
    const { images, hasParent } = this.props;

    if (Object.keys(hasParent).length !== 0) {
      return null;
    }

    const calculatedPlaceholders = images.map(key => (
      <div key={`categorykey-${key.fileName}`} onClick={() => this.setBackgroundImage(key)} className="backgroundColors">
        <img alt="" src={key.previewUrl} />
      </div>
    ));

    return calculatedPlaceholders;
  }

  render() {
    return (
      <div className="CategoryColors" style={{ height: 160 }}>
        { this.renderColors() }
      </div>
    );
  }
}

CategoryColors.defaultProps = {
  images: [],
  layouts: {},
  dispatch: () => {},
  backgrounds: {},

};

CategoryColors.propTypes = {
  images: PropTypes.array,
  layouts: PropTypes.object,
  dispatch: PropTypes.func,
  backgrounds: PropTypes.object,

};


export default (CategoryColors);



// WEBPACK FOOTER //
// ./src/components/layout-gallery/CategoryColors.jsx